import ImagePerson from "@/components/functionals/ImagePerson";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import formatterTask from "@/components/functionals/formatterTask.vue";
import BlinkingObjective from "@/components/functionals/BlinkingObjective";
import PercentageAndColorFormatter from "@/components/functionals/PercentageAndColorFormatter";
import HyperLinkTasksDetails from "@/components/cmi/ObjectivesReport/HyperLinkTasksDetails";

/*
          Codigos para diferencias los detalles de tareas segun la columna (TaskCode)
            * TT - Total de Tareas
            * TR - Tareas Realizadas
            * TRTR - Tareas Retrasadas
            * TCSAnt - Tareas Cerradas Semana Anterior
            * TCSAct - Tareas Cerradas Semana Actual
            * TP - Tareas pendientes en progreso
            * TSA - Tareas Semana Actual
            * TSP - Tareas senmana proxima
      */
export const ObjectivesReportColumns = (thiss) => [
  {
    prop: "ObjectiveCombinedId",
    label: "No",
    "min-width": 100,
    sortable: true,
    align: "center",
    fixed: true,
    formatter: BlinkingObjective
  },
  {
    prop: "ObjectiveShortDescription",
    label: "Descripción",
    "min-width": 500,
    sortable: true,
    fixed: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "ResponsibleName",
    label: "Responsable",
    "min-width": 300,
    sortable: true,

    formatter: ImagePerson,
    attrs: {
      imgKey: "ResponsiblePhoto"
    }
  },
  {
    prop: "DelayedDays",
    label: "Retraso",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: PercentageAndColorFormatter
  },
  {
    prop: "ExecutionPercentage",
    label: "% de Ejecución",
    "min-width": 150,
    sortable: true,
    align: "center",
    //fixed: true,
    formatter: PercentageAndColorFormatter
  },
  {
    prop: "WeekBeforeAdvance",
    label: "Avance Semana Anterior",
    "min-width": 210,
    sortable: true,
    align: "center",

    formatter: PercentageAndColorFormatter
  },
  {
    prop: "ActualWeekAdvance",
    label: "Avance Semana Actual",
    "min-width": 200,
    sortable: true,
    align: "center",

    formatter: PercentageAndColorFormatter
  },
  {
    prop: "DateInit",
    label: "Fecha de Inicio",
    "min-width": 150,
    sortable: true,
    align: "center",
    formatter: DatetimeFormatter
  },
  {
    prop: "DateEnd",
    label: "Fecha de Fin",
    "min-width": 150,
    sortable: true,
    align: "center",
    formatter: DatetimeFormatter
  },
  {
    prop: "DaysDuration",
    label: "Días",
    "min-width": 90,
    sortable: true,
    align: "center"
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TasksCount",
    label: "Total de Tareas",
    "min-width": 150,
    sortable: true,
    align: "center",
    attrs: {
      // TT - Total de Tareas
      TaskCode: "TT",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },
  {
    prop: "DoneTasksCount",
    label: "Tareas Realizadas",
    "min-width": 170,
    sortable: true,
    align: "center",
    attrs: {
      // TR - Tareas Realizadas
      TaskCode: "TR",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },
  {
    prop: "DelayedTasksCount",
    label: "Tareas Retrasadas",
    "min-width": 170,
    sortable: true,
    align: "center",
    attrs: {
      // TR - Tareas Realizadas
      TaskCode: "TRTR",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },
  {
    prop: "WeekBeforeClosedTasksCount",
    label: "Cerradas Semana Anterior",
    "min-width": 220,
    sortable: true,
    align: "center",
    attrs: {
      // TCSAnt - Tareas Cerradas Semana Anterior
      TaskCode: "TCSAnt",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },
  {
    prop: "ActualWeekClosedTasksCount",
    label: "Cerradas Semana Actual",
    "min-width": 220,
    sortable: true,
    align: "center",
    attrs: {
      // TCSAct - Tareas Cerradas Semana Actual
      TaskCode: "TCSAct",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },

  {
    prop: "InProgressTasksCount",
    label: "Tareas Pendientes",
    "min-width": 170,
    sortable: true,
    align: "center",
    attrs: {
      // TP - Tareas pendientes en progreso
      TaskCode: "TP",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },

  {
    prop: "ActualWeekTasksCount",
    label: "Tareas Semana Actual (x)",
    "min-width": 220,
    sortable: true,
    align: "center",
    attrs: {
      // TSA - Tareas Semana Actual
      TaskCode: "TSA",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },
  {
    prop: "WeekAfterTasksCount",
    label: "Tareas Semana (X+1)",
    "min-width": 220,
    sortable: true,
    align: "center",
    attrs: {
      // TSP - Tareas senmana proxima
      TaskCode: "TSP",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },
  {
    prop: "WeekAfterMas1TasksCount",
    label: "Tareas Semana (X+2)",
    "min-width": 220,
    sortable: true,
    align: "center",
    attrs: {
      // TSPM1 - Tareas senmana proxima + 1
      TaskCode: "TSPM1",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },
  {
    prop: "WeekAfterMas2TasksCount",
    label: "Tareas Semana (X+3)",
    "min-width": 220,
    sortable: true,
    align: "center",
    attrs: {
      // TSPM2 - Tareas senmana proxima + 2
      TaskCode: "TSPM2",
      OpenTasks: thiss.OpenTasks
    },
    formatter: HyperLinkTasksDetails
  },

  {
    prop: "TypeStrategic",
    label: "Tipo de Objetivo",
    "min-width": 170,
    sortable: true,
    align: "center",
    formatter: formatterTask
  },
  {
    prop: "PerpectiveID",
    label: "Perspectiva",
    "min-width": 150,
    sortable: true,
    align: "center",
    formatter: formatterTask
  }
];

export const ObjectiveReportActions = (thiss, options = {}) => [
  // {
  //   icon: "el-icon-view",
  //   label: "Ver Detalle",
  //   command: "view_task"
  // },
  {
    icon: "el-icon-view",
    label: "Ver Tareas",
    command: "view_tasks"
  },
  {
    icon: "el-icon-plus",
    label: "Crear Tareas",
    command: "create_tasks",
    condition: (row) => {
      // Condicion para que solo lo puedan ver los supervisores
      if (typeof options.canCreateTasks === "function") {
        return options.canCreateTasks(row, thiss);
      }

      if (typeof options.canCreateTasks === "boolean") {
        return options.canCreateTasks;
      }

      return true;
    }
  },
  {
    icon: "el-icon-edit",
    label: "Editar Objetivo",
    command: "edit_objective"
    //condition: (row) => (row.ResponsableId !== thiss.currentUser.EmployeeId)
    // condition: async (row) => {
    //   const isSup = new verifyIfIsSupervisor();
    //   const result = await isSup.KnowIfIsHisSupervisor(row.CreatedBy, thiss);
    //   return result;
    // }
  },

  {
    icon: "el-icon-delete",
    label: "Eliminar Objetivo",
    command: "delete_objective"
    //condition: (row) => (row.ResponsableId !== thiss.currentUser.EmployeeId)
    // condition: async (row) => {
    //   const isSup = new verifyIfIsSupervisor();
    //   const result = await isSup.KnowIfIsHisSupervisor(row.CreatedBy, thiss);
    //   return result;
    // }
  },
  {
    icon: "el-icon-refresh",
    label: "Recalcular porcentaje",
    command: "update_objective_percentage"
  }
];
// class verifyIfIsSupervisor {
//   async KnowIfIsHisSupervisor(responsible, thiss) {
//     this.AmIsupervisor = false;
//     await thiss.$http
//       .get("/api/ReporteGestion/IsHisSupervisor", {
//         params: {
//           responsibleID: responsible,
//           currentUserEmpId: this.currentUser.EmployeeId
//         }
//       })
//       .then((response) => {
//         const AmIsupervisor = response.data;
//         return AmIsupervisor;
//       });
//   }
// }
